module.exports = "<svg viewBox=\"0 0 17 16\" xmlns=\"http://www.w3.org/2000/svg\"><path d=\"M6.63 8L1.19 2.56A1.5 1.5 0 1 1 3.31.44l5.44 5.44L14.19.44a1.5 1.5 0 1 1 2.12 2.12L10.87 8l5.44 5.44a1.5 1.5 0 1 1-2.12 2.12l-5.44-5.44-5.44 5.44a1.5 1.5 0 1 1-2.12-2.12L6.63 8z\" fill=\"#CCC\" fill-rule=\"evenodd\"></path></svg>"


//////////////////
// WEBPACK FOOTER
// ./node_modules/svg-inline-loader?removeTags=true!./src/images/icons/times-icon.svg
// module id = +Juk
// module chunks = 89